angular.module('aq.filters.transformers')
.filter("reverse", function() {
    return function(input) {
        return input ? input.reverse() : [];
    }
});